import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { updatePartner } from 'panel/partner/redux/actions'

const initialState = { productionMin: 0, productionMinTime: 0, productionMaxTime: 0 }
const PartnerProductionTime: React.FC = () => {
  const [form, setForm] = useState(initialState)

  const dispatch = useDispatch()
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)

  function handleUpdate (): void {
    if (partner) {
      const formData = new FormData()
      formData.set('productionMin', String(form.productionMin))
      formData.set('productionMinTime', String(form.productionMinTime))
      formData.set('productionMaxTime', String(form.productionMaxTime))
      updatePartner(partner.id, formData, false)(dispatch)
    }
  }

  useEffect(() => {
    if (partner) {
      setForm({
        productionMin: partner.productionMin || 0,
        productionMinTime: partner.productionMinTime || 0,
        productionMaxTime: partner.productionMaxTime || 0
      })
    }
  }, [partner])

  return (
    <form className="row" onSubmit={handleUpdate}>
      <div className="row">
        <div className="form-control col-4">
          <label>Valor Mínimo</label>
          <input
            type="number"
            value={form.productionMin}
            onChange={(e): void => setForm({ ...form, productionMin: parseInt(e.target.value) })}
            onBlur={(): void => handleUpdate()}
            required
          />
        </div>
        <div className="form-control col-4">
          <label>Prazo Mínimo</label>
          <input
            type="number"
            value={form.productionMinTime}
            onChange={(e): void => setForm({ ...form, productionMinTime: parseInt(e.target.value) })}
            onBlur={(): void => handleUpdate()}
            required
          />
        </div>
        <div className="form-control col-4">
          <label>Prazo Máximo</label>
          <input
            type="number"
            value={form.productionMaxTime}
            onChange={(e): void => setForm({ ...form, productionMaxTime: parseInt(e.target.value) })}
            onBlur={(): void => handleUpdate()}
            required
          />
        </div>
      </div>
    </form>
  )
}

export default PartnerProductionTime
